import { openLink, openTelegramLink } from "@tma.js/sdk-react"

function isTelegramLink(url: string): boolean {
	return /^https?:\/\/t\.me\//i.test(url)
}

export function openExternalLink(url: string) {
	if (isTelegramLink(url) && openTelegramLink.isAvailable()) {
		openTelegramLink(url)
		return
	}
	if (openLink.isAvailable()) {
		openLink(url)
		return
	}
	window.open(url, "_blank", "noopener,noreferrer")
}
